import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class RefreshTokenResponse {
  @jsonMember(String)
  public readonly token!: string;
}
